__turbopack_context__.v({
  "action": "AssuredLoadStatus-module-scss-module__e_wPha__action",
  "bid": "AssuredLoadStatus-module-scss-module__e_wPha__bid",
  "desc": "AssuredLoadStatus-module-scss-module__e_wPha__desc",
  "iconWrapper": "AssuredLoadStatus-module-scss-module__e_wPha__iconWrapper",
  "load": "AssuredLoadStatus-module-scss-module__e_wPha__load",
  "lorry": "AssuredLoadStatus-module-scss-module__e_wPha__lorry",
  "main": "AssuredLoadStatus-module-scss-module__e_wPha__main",
  "misc": "AssuredLoadStatus-module-scss-module__e_wPha__misc",
  "payment": "AssuredLoadStatus-module-scss-module__e_wPha__payment",
  "waitingAction": "AssuredLoadStatus-module-scss-module__e_wPha__waitingAction",
  "wrapper": "AssuredLoadStatus-module-scss-module__e_wPha__wrapper",
});
